export default __webpack_public_path__ + "static/media/mood-smile.94ee77a4.svg";